import axios from 'axios';
import { parseInvoiceFiles } from '@/general/converters/mediaFileConverters2';
import InvoiceFile from '@/general/models/InvoiceFile';
import { ContentId } from '@/general/models/MediaFile';
import { formatDossierContactTargets } from '@/shared/converters/dossierContactTargetConverters';
import { present } from '@/shared/utils/typescript';
import { parsePaymentRequest, parsePaymentRequests } from '../converters/paymentRequestConverters';
import { DossierId } from '../models/AbstractDossier';
import PaymentRequest, { PaymentRequestId } from '../models/PaymentRequest';
import { PaymentRequestClientData } from '../models/PaymentRequestData';

export default class PaymentRequestClient {
  static async uploadAttachment(file: File, dossierId: DossierId): Promise<ContentId> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`/api/mobopro/v1/dossiers/${dossierId}/paymentinfo/media`, formData);
    return response.data.moboMediaFileId;
  }

  static async loadAll(dossierId: DossierId): Promise<Array<PaymentRequest>> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossierId}/paymentinfo`);
    return parsePaymentRequests(response.data.paymentRequests);
  }

  static async create(data: PaymentRequestClientData, dossierId: DossierId): Promise<PaymentRequest> {
    const payload = {
      isPaymentRequired: true,
      targets: formatDossierContactTargets(data.targets),
      paymentInformation: {
        moboMediaFileId: data.attachment,
        reference: data.reference,
        amount: data.amount,
      },
    };
    const response = await axios.post(`/api/mobopro/v1/dossiers/${dossierId}/paymentinfo`, payload);
    return present(parsePaymentRequest(response.data.paymentRequest));
  }

  static async remove(id: PaymentRequestId, dossierId: DossierId): Promise<void> {
    await axios.delete(`/api/mobopro/v1/dossiers/${dossierId}/paymentinfo/${id}`);
  }

  static async getInvoiceFiles(dossierId: DossierId): Promise<Array<InvoiceFile>> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossierId}/dmsinvoices`);
    return parseInvoiceFiles(response.data);
  }
}
